import { FC } from 'react';
import { FMHLink } from '../fmh-link';
import LinkListProps from './dto';
import Style from './ff-link-list.module.scss';
import { FFHeading, HeadingSizeProp } from '@/atoms/ff-heading';

const FFLinkList: FC<LinkListProps> = (props: LinkListProps): JSX.Element => {
    const list = props.links.map((element) => {
        if (props.isHorizontal) {
            return (
                <li className={`${Style.horizontalListLinks} ff-mb-8 ff-mb-lg-0`} key={element.text}>
                    <FMHLink className={`ff-mr-xl-32 ff-mr-16 overline ${Style.link}`} href={element.ref}>
                        {element.text}
                    </FMHLink>
                </li>
            );
        } else {
            return (
                <li className={`ff-mb-8`} key={element.text}>
                    <FMHLink className={`${Style.link}`} href={element.ref}>
                        {element.text}
                    </FMHLink>
                </li>
            );
        }
    });

    return (
        <div className={`${Style.linkListContainer} ${props.isHorizontal ? Style.horizontalList : Style.verticalList}`}>
            {props.listTitle ? (
                <FFHeading text={props.listTitle} className="ff-mb-16" size={HeadingSizeProp.H5} />
            ) : null}
            <ul className={Style.linkList}>{list}</ul>
        </div>
    );
};

export default FFLinkList;
